import { render, staticRenderFns } from "./ProductIconComponent.vue?vue&type=template&id=61787f74&scoped=true&"
import script from "./ProductIconComponent.vue?vue&type=script&lang=ts&"
export * from "./ProductIconComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ProductIconComponent.vue?vue&type=style&index=0&id=61787f74&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61787f74",
  null
  
)

export default component.exports